import axios from 'axios';

// Use relative URL in production, localhost in development
const API_URL = process.env.NODE_ENV === 'production' 
  ? '/api' 
  : (process.env.REACT_APP_API_URL || 'http://localhost:3001/api');

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle 401 errors (but skip for blob responses)
api.interceptors.response.use(
  (response) => {
    // Don't process blob responses through interceptor
    if (response.config.responseType === 'blob') {
      return response;
    }
    return response;
  },
  (error) => {
    // Don't redirect on 401 for blob requests (let the error handler deal with it)
    if (error.response?.status === 401 && error.config?.responseType !== 'blob') {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;

